import { useState } from "react";
import moment from "moment";
import { Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import TimeInput from "components/atoms/TimeInput/TimeInput";
import FormHr from "pages/shipper/RequestForm/components/Common/FormHr";
import PickupDeliveryDate from "pages/shipper/RequestForm/components/Schedule/PickupDeliveryDate";
import { IQuotationData } from "pages/provider/QuotationDetail/QuotationType";
import { ICountries } from "pages/shipper/RequestForm/components/Schedule/Types";

interface IPickupProps {
  quoteRequestDetails: IQuotationData;
  countries: ICountries[];
}

function Pickup(props: IPickupProps) {
  const { quoteRequestDetails, countries } = props;
  const [holidays, setHolidays] = useState({});

  const { pickup_date, pickup_time, pickup_city, pickup_country_code } = quoteRequestDetails?.schedule || {};

  return (
    <>
      <div className="flex-row mb-24">
        <div className="w-200 pl-16 pr-16">
          <Row className="mb-1">
            <h6>
              <FormattedMessage id="general.pickup" defaultMessage="Pickup" />
            </h6>
          </Row>
          <Row className="font-b3 text-secondary">
            <p className="font-b2">
              {`${moment(pickup_date).format("MMMM DD, YYYY")} - ${moment(pickup_time, "HH:mm:ss").format("HH:mm")}`}
            </p>
          </Row>
          <Row className="font-b3 text-secondary">
            <p className="font-b2">{`${pickup_city}, ${pickup_country_code}`}</p>
          </Row>
        </div>
        <div className="flex-row mt-2">
          <div className="w-192 align-date">
            <label className="required">
              <FormattedMessage id="quote.provider.latestPickupTime" defaultMessage="Latest pickup time" />
            </label>
            <PickupDeliveryDate
              datePickerProps={{
                name: "schedule.pickup_date",
                required: true,
              }}
              countries={countries}
              holidays={holidays}
              setHolidays={setHolidays}
            />
          </div>
          <div className="mt-2">
            <label />
            <TimeInput name="schedule.pickup_time" defaultValue="17:00:00" required />
          </div>
        </div>
      </div>
      <FormHr />
    </>
  );
}

export default Pickup;
